import { useEffect, useMemo, useState } from "react";
import { createPortal } from "react-dom";

/**
 * Portaluje dzieci do document.body, aby "position: fixed" było względem viewportu,
 * niezależnie od transform/scale rodziców.
 */
export default function FabPortal({ children }) {
    const [mounted, setMounted] = useState(false);

    useEffect(() => {
        setMounted(true);
        return () => setMounted(false);
    }, []);

    const fabNode = useMemo(() => {
        const el = document.createElement("div");
        el.className = "fab-portal-root";
        el.style.position = "fixed";
        el.style.right = "16px";
        el.style.bottom = "16px";
        el.style.zIndex = "10020";
        return el;
    }, []);

    useEffect(() => {
        if (!mounted) return;
        document.body.appendChild(fabNode);
        return () => {
            try {
                document.body.removeChild(fabNode);
            } catch { }
        };
    }, [mounted, fabNode]);

    if (!mounted) return null;
    return createPortal(children, fabNode);
}
